var commissions = {
  split_fractions: v=>v.map(r=>
    r.role.name+': '+r.fraction_for_employee).join(', '),
  will_be_payed: v=>v.map(r=>
    r.role.name+': '+(r.payed?'Si':'No')).join(', '),
  fractions_to_be_payed: v=>v.map(r=>
    r.role.name+': '+r.fraction).join(', '),
  half_commission_thresholds:v=>v.map(r=>
  r.half_threshold),
  full_commission_thresholds:v=>v.map(r=>
  r.full_threshold),
  complete_commissions:v=>v.map(r=>
  r.value/100),
  employee_commission_level:v=>Array.isArray(v)?v.map(r=>
    r.level):v
}
export const breakdownFormatters = {
  new_sales_commissions:commissions,
  upgrades_commissions: commissions,
  loan_payments: {
    id: v=>v=='loan'?'Préstamo':
      (v=='health_insurance'?'Seguro de gastos médicos':
        v=='car_insurance'?'Seguro de auto':
        v=='tenis'?'Tenis':
        v=='fonacot'?'Fonacot':
        v=='infonavit'?'Infonavit':
        v=='vive-inmense'?'Vive inmense':'Desconocido')
  },
  infonavit: {
    id: v=>v=='loan'?'Préstamo':
      (v=='health_insurance'?'Seguro de gastos médicos':
        v=='car_insurance'?'Seguro de auto':
        v=='tenis'?'Tenis':
        v=='fonacot'?'Fonacot':
        v=='infonavit'?'Infonavit':'Desconocido')
  },
  payments_commissions:{
    pending_commission:p=>p.map(r=>
      r.pending_commission),
    half_commission_threshold:p=>p['half_commission_threshold'],
    complete_commission:p=>p.complete_commission,
    // amount:p=>p.amount
  },
  payer: {
    percentage: p=>p+'%'
  },
  cancelations_and_downgrades: {
    warning: t=>t?'Si':'No',
  },
  qs_commissions:{
    q_amount: a=>a.amount+" "+a.currency,
    will_be_payed:a=>a?'Si':'No'
  }
}
